import React from 'react';
import { useTranslation } from 'react-i18next';

import { OmaLummeApp } from '../../../../omaLummeContext';
import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsRadio from '../ManageContractsRadioCheckbox';
import { generateAddress } from '../../../../utils/address';

export const ChangePrimaryAddress: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { users } = OmaLummeApp.useState();
  const { startDate, newAddress, changePrimaryAddress } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepChangePrimaryAddress">
      <h3>{t('manageContracts:manageContracts.ChangePrimaryAddressTitle')}*</h3>

      {newAddress && (
        <div className="form-items">
          <ManageContractsRadio
            radioID="manageContractsChangePrimaryAddressYes"
            radioName="manageContractsChangePrimaryAddress"
            onChangeFunc={(): void => {
              dispatch(['primaryAddressChange', true]);
              dispatch(['newAddressDate', startDate]);
              dispatch(['newPrimaryAddress', newAddress]);
            }}
            checkedComparison={changePrimaryAddress === true}
            label={`${t('manageContracts:manageContracts.ChangePrimaryAddressYes')} <strong>${generateAddress(newAddress, false)}</strong>`}
          />

          <ManageContractsRadio
            radioID="manageContractsChangePrimaryAddressNo"
            radioName="manageContractsChangePrimaryAddress"
            onChangeFunc={(): void => dispatch(['primaryAddressChange', false])}
            checkedComparison={changePrimaryAddress === false}
            label={`${t('manageContracts:manageContracts.ChangePrimaryAddressNo')} <strong>${generateAddress(
              users.activeUser.userAddress[0],
              false,
            )}</strong>`}
          />
        </div>
      )}
    </section>
  );
};

export default ChangePrimaryAddress;
